"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollBarWidth = void 0;
let scrollMeasureWrapperElement = null;
let scrollMeasureInnerElement = null;
function getScrollBarWidth() {
    if (!scrollMeasureWrapperElement || !scrollMeasureInnerElement) {
        scrollMeasureWrapperElement = document.createElement('div');
        scrollMeasureWrapperElement.style.cssText = `
            position: fixed;
            bottom: 100%; 
            left: 0; 
            background: transparent; 
            width: 50px; 
            height: 50px; 
            overflow: auto;
        `;
        scrollMeasureInnerElement = document.createElement('div');
        scrollMeasureInnerElement.style.cssText = 'width: 100%; height: 60px;';
        scrollMeasureWrapperElement.appendChild(scrollMeasureInnerElement);
        document.body.appendChild(scrollMeasureWrapperElement);
    }
    return scrollMeasureWrapperElement.offsetWidth - scrollMeasureInnerElement.offsetWidth;
}
exports.getScrollBarWidth = getScrollBarWidth;
//# sourceMappingURL=getScrollBarWidth.js.map